/* src/app/components/payroll/timesheets/timesheet-staff-errorcode/timesheet-staff-errorcode.component.css */
.custom-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=timesheet-staff-errorcode.component-VSBO7ZVV.css.map */
